export class API {
  static login = "api/login";
  static getPositionTreeView = "api/organization/position-tree";
  static getMasters = "api/getMasters";
  static getNewOTP = "api/auth/session/otp";
  static changePassword = "api/changePassword";
  static getUserSessions = "api/getUserSessions";
  static getUserLogs = "api/getUserLogs";
  static getActualTourPlan = "api/plans/tours/actual";
  static getTourPlan = "api/plans/tours/list";
  static getTeamAttendance = "api/reports/attendance/team";
  static getAllowedMonths = "api/config/allowed-months";
  static getCompanyDetails = "api/config/company";
  static getEffortReport = "api/getEffortReport";
  static getDarReport = "api/getDarReport";
  static getMasReport = "api/getMasReport";
  static getOvpReport = "api/getOvpReport";
  static sendPushNotification = "api/sendPushNotification";
  static getNotification = "api/notifications";
  static getEmployeeInfo = "api/getEmployeeInfo";
  static UpdateEmployeeDetails = "api/UpdateEmployeeDetails";
  static unlockAccount = "api/UnlockEmpAccount";
  static UnlockDays = "api/plans/tours/unlock";
  static getEmployeeAttendance = "api/getEmployeeAttendance";
  static getAttendanceSummary = "api/reports/attendance/summary";
  static getEmployees = "api/getEmployees";
  static getFtpImportBatches = "api/getFtpImportBatches";
  static getFtpExportBatches = "api/getFtpExportBatches";
  static getFtpImportLogs = "api/getFtpImportLogs";
  static getFtpExportLogs = "api/getFtpExportLogs";
  static getActivityKpis = "api/kpis/activities";
  static getTeamMtpStatus = "api/reports/mtp/team-status";
  static getRequestedMTPByPosition = "api/plans/mtp/requests";
  static getMTPListV2 = "api/plans/mtp/v2";
  static createMTP = "api/plans/mtp/create";
  static getMtpByIdV2 = "api/plans/mtp/ById";
  static approveMTP = "api/plans/mtp/approve";
  static rejectMTP = "api/plans/mtp/reject";
  static submitMTP = "api/plans/mtp/submit";
  static resetMTP = "api/plans/mtp/reset";
  static pendingLeaveCountList = "api/leaves/requests/pending";
  static getEmployeeLeave = "api/leaves";
  static getLeaveStatus = "api/leaves/statuses";
  static leaveApprove = "api/leaves/approve";
  static leaveReject = "api/leaves/reject";
  static getMyTeam = "api/users/me/team";
  static expenseOverview = "api/expenses/overview";
  static empDateWiseExpense = "report/empDateWiseExpense";
  static getExpensesNew = "api/expenses/list";
  static getStatus = "api/system/status";
  static getExpensesMaster = "api/expenses/master-data";
  static editApprovalExpenses = "api/editApprovelExpenses";
  static addMoreExp = "api/addMoreExp";
  static addMoreExpPost = "api/addMoreExpPost";
  static expensesSubmit = "api/expensesSubmit";
  static getWorkingDays = "api/attendance/working-days";
  static expensesApproved = "api/expenses/status/approved";
  static deleteExpenseList = "api/expenses/delete";
  static getExpenseListDetails = "api/expenses/line-items";
  static createExpenseListDetailss = "api/expenses/line-items/create";
  static deleteExpenseListDetails = "api/expenses/line-items/delete";
  static updateExpenseListDetails = "api/expenses/line-items/update";
  static getExpenseListDetailsById = "api/expenses/line-items/id";
  static getExpenseLastDates = "api/expenses/submission/due-dates";
  static getProfile = "api/users/me";
  static getSGPIBalance = "api/sgpi/balance";
  static getOutletTypes = "api/outlets/types";
  static getEmployeeLeaveBalance = "api/leaves/balance";
  static getSgpiOutReport = "api/getSgpiOutReport";
  static getRcpaSkuSummary = "api/getRcpaSkuSummary";
  static getPodReport = "api/getPodReport";
  static getJwReport = "api/getJwReport";
  static getJwDateWiseReport = "api/getJwDateWiseReport";
  static getExpensesSummary = "api/getExpensesSummary";
  static getExpenseStatus = "api/getExpenseStatus";
  static pendingAdminLeaveCountList = "api/pendingAdminLeaveCountList";
  static getMtpDayById = "api/plans/mtp/days";
  static deleteTourPlan = "api/plans/tours/delete";
  static addTourPlan = "api/plans/tours/add";
  static getTerritoriesArray = "api/territories/array";
  static getMtpAgendas = "api/plans/mtp/agendas";
  static getBeats = "api/beats";
  static getCustomerForJW = "api/customers/jw";
  static getCustomersByBeat = "api/beats/customers";
  static searchTown = "api/locations/towns/search";
  static classificationChart = "api/classificationChart";
  static activeVacantTerritories = "api/activeVacantTerritories";
  static mtpStatusByDesignation = "api/mtpStatusByDesignation";
  static PendingAttendanceReport = "api/PendingAttendanceReport";
  static MtpDetailReport = "api/MtpDetailReport";
  static leaveBalanceReport = "api/leaveBalanceReport";
  static leaveTypes = "api/leaves/types";
  static getLeaveTypes = "api/leaves/types";
  static getLeaveById = "api/leaves/ById";
  static createLeave = "api/leaves/create";
  static checkDays = "api/checkDays";
  static uploadMediaBase64 = "api/media/upload/Base64";
  static uploadFile = "api/media/upload/file";
  static downloadFile = "api/media/download";
  static leaveCancelled = "api/leaves/cancelled";
  static RCPAsalePrescription = "api/potentialCustomerBasedRCPA";
  static targetAchievement = "api/target_achievement";
  static getSupportCaptureSummary = "api/support/getSupportCaptureSummary";
  static dailyEffortReport = "api/getDailyEffortReport";
  static getTargetAchievementReport = "api/getTargetAchievementReport";
  static getEmployeeClaimReport = "api/getEmployeeClaimReport";
  static getPrimarySecondaryStockiestReport =
    "api/getPrimarySecondaryStockiestReport";
  static visitActivityReport = "api/reports/visitActivityReport";

  static getAverageReport = "api/getAverageReport";
  static pendingDcrReport = "api/getPendingDcrReport";
  static getEmployeeLatLng = "api/maps/employee-latlng"; // API 1: takes Date, Employee Code
  static getOlaMapRoute = "api/maps/ola-route";          // API 2: takes latitude, longitude
  static getMasReportV2 = "api/getMasReportV2";
  static getDarReportV2 = "api/getDarReportV2";
  static getSgpiOutReportV2 = "api/getSgpiOutReportV2";
  static getMasReportV3 = "api/getMasReportV3";
  static getOutletViewReport = "api/getOutletViewReport";
  static getJwReportV2 = "api/getJwReportV2";
  static punchStatus = 'api/attendance/status';
  static punchStatusByDate = 'api/attendance/date';
  static punchin = 'api/attendance/punches/in';
  static punchout = 'api/attendance/punches/out';
  static towns = 'api/territories/towns';
  static getJointWork = 'api/attendance/joint-work';
  static updateJointWork = 'api/attendance/joint-work/update';
  static getFieldWork = 'api/attendance/field-work';
  static updateFieldWork = 'api/attendance/field-work/update';
  static getNca = 'api/attendance/nca';
  static updateNca = 'api/attendance/nca/update';

  static getAllSubmittedPodLineItems = 'api/pod/submissions/line-items';
  static getPodStatus = 'api/pod/statuses';
  static statusUpdate = 'api/pod/submissions/status';
  static getPodSummary = 'api/pod/submissions/summary';

  static GetAllSubmittedOutlets = 'api/support/getSubmittedSupportOutlets';
  static ProductListingId = 'api/support/supportCaptureById';
  static ApproveRejectSupport = 'api/support/actionSupportCapture';

  static GetAllClosingStock = 'api/outlet/getClosingStock';
  static GetAllClosingStockDetails = 'api/outlet/getClosingStockDetails';
  static UpdateClosingStockStatus = 'api/outlet/updateClosingStockStatus';

  // Optional Holidays
  static getHolidayList = 'api/calendars/holidays';
  static getOptionalHolidays = 'api/attendance/optional-holidays';
  static submitHolidayRequest = 'api/attendance/optional-holidays/submit';
  static getHolidayRequests = 'api/attendance/optional-holidays/request-details';
  static actionHolidayRequest = 'api/attendance/optional-holidays/action';
  static geofencing = 'api/geofencing';

  // Brand Campaign
  static brand_campaign = 'api/brand_campiagn';
  static campaign_details = 'api/campaigns/details';
  static doctor_list = 'api/doctors/list';
  static getCampaignStatus = 'api/campaigns/statuses';
  static add_doctor = 'api/doctors/add';

  // Watermelon DB Bridge APIs
  static getBrands = 'api/getBrands';
  static getEdPresentation = 'api/getEdPresentation';
  static getSgpiBalance = 'api/getSgpiBalance';
  static getSystemConfigs = 'api/getSystemConfigs';
  static getTranslatedLabels = 'api/getTranslatedLabels';
  static getCustomTabs = 'api/getCustomTabs';

  // Day Plan & Outlets APIs
  static fetchOutlets = 'api/fetchOutlets';
  static insertDayPlan = 'api/insertDayPlan';

  // Lock / Unlock Attendance APIs
  static createAttendanceLockReq = 'api/createAttendanceLockReq';
  static getAttendanceByDate = 'api/getAttendanceByDate';
  static getTeamLockRequest = 'api/getTeamLockRequest';
  static approveRejectAttendanceLockReq = 'api/approveRejectAttendanceLockReq';
}
